<template>
  <v-container fluid>
    <v-container>
      <h1 class="text-h3">{{ location.name }}</h1>
    </v-container>
    <v-container>
      <v-card tile>
        <v-card-title>{{ $t("locationTools") }}</v-card-title>
        <v-container>
          <v-row class="px-1">
            <v-col class="px-2 py-0 col-5">
              <v-card>
                <early-booking-table></early-booking-table>
              </v-card>
            </v-col>
            <v-col class="px-2 py-0 col-7">
              <v-card>
                <web-hooks-table></web-hooks-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EarlyBookingTable from "@/components/EarlyBookingTable.vue";
import WebHooksTable from "@/components/WebHooksTable.vue";
import store from "../store";

export default {
  name: "Tools",

  components: { EarlyBookingTable, WebHooksTable },

  beforeRouteEnter: async (to, from, next) => {
    await store.dispatch("loadLocation", to.params.location_id);
    next();
  },

  computed: {
    ...mapGetters(["location"]),
  },
};
</script>
